import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'

import Cross from 'components/icons/Cross'

import './styles.css'

class Modal extends Component {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    modalHeader: PropTypes.bool,
    modalHeaderSeperator: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    modalTitle: PropTypes.any,
    // eslint-disable-next-line react/forbid-prop-types
    className: PropTypes.any,
    additionalClassName: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    overlayClassName: PropTypes.any,
  }

  static defaultProps = {
    modalHeader: true,
    modalHeaderSeperator: false,
    modalTitle: undefined,
    additionalClassName: undefined,
    className: {
      base: 'modal',
      afterOpen: 'modal--open',
    },
    overlayClassName: 'modal--overlay',
  }

  render() {
    const {
      children,
      modalHeader,
      modalHeaderSeperator,
      modalTitle,
      isOpen,
      onRequestClose,
      className,
      additionalClassName,
      overlayClassName,
    } = this.props

    let resolvedClassName;
    if (additionalClassName){
      resolvedClassName = {
        base: `${className.base} ${additionalClassName}`,
        afterOpen: className.afterOpen,
      }
    } else {
      resolvedClassName = className
    }

    const modalHeaderClass = (modalHeaderSeperator) ? "modal-header modal-header-seperator" : "modal-header";
    const modalHeaderDisplay = (
      <div className={modalHeaderClass}>
        <div className="modal-close-container">
          <a onClick={onRequestClose}>
            <Cross customClassName="modal-close-icon" width={50} />
          </a>
        </div>
        <div className="modal-title">
          {modalTitle}
        </div>
      </div>
    )

    // console.log({modalTitle})

    return (
      <ReactModal
        isOpen={isOpen}
        contentLabel="Modal"
        onRequestClose={onRequestClose}
        shouldCloseOnOverlayClick={false}
        className={resolvedClassName}
        overlayClassName={overlayClassName}
      >
        {modalHeader && modalHeaderDisplay}
        {children}
      </ReactModal>
    )
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/_molecules/Modal/index.js